export const transparentBorder = `1px solid transparent`
export const globalTransition = `0.25s ease-in-out`
